import { REPORTS_RECEIVE_SCORES } from 'components/constants';
export var ReportsMessageTypes = {
    scoreListing: {
        type: REPORTS_RECEIVE_SCORES,
        payload: function (payload) { return payload.scoreListing; }
    }
};
